import { useTranslation } from "react-i18next";
import { Flex, Box } from "@chakra-ui/react";
import { Status } from "src/hooks/useAudioController";
import AudioPlayer from "src/components/AudioPlayer";
import IconAsButton from "src/components/IconAsButton";
import AudioLoader from "src/components/AudioLoader";
import { Subtitle, BodyText2 } from "src/atoms/typography";
import { ReactComponent as PlayIcon } from "src/modules/lullaby/icons/play-circle-125.svg";
import { ReactComponent as StopIcon } from "src/modules/lullaby/icons/stop-circle-125.svg";
import time from "src/utils/time";

function PlayingContent({ audioController, lullaby }) {
  return (
    <Flex pr="4px" flex="1 1 auto" width="100%">
      <Box flex="0 0 auto">
        <IconAsButton
          onClick={audioController.pause}
          mr="2px"
          icon={StopIcon}
          fill="mediumEmphasis"
          size="16px"
        />
      </Box>
      <AudioPlayer
        getCurrentTime={audioController.getCurrentTime}
        duration={lullaby.duration}
        onSeek={audioController.seek}
        onSeekCommitted={audioController.seekCommitted}
      />
    </Flex>
  );
}

function RestingContent({ t, lullaby, audioController }) {
  let name = lullaby.name;
  const libraryIdentifier = lullaby.identifier || lullaby.libraryIdentifier;
  if (libraryIdentifier) {
    name = t(`lullaby.name.${libraryIdentifier}`);
  }
  return (
    <Flex flexDirection="column">
      <Subtitle mb="1px" color="highEmphasis">
        {name}
      </Subtitle>
      <Flex alignItems="center">
        <IconAsButton
          onClick={() =>
            audioController.play({
              identifier: lullaby.objectId,
              srcResolverInput: lullaby
            })
          }
          mr="6px"
          icon={PlayIcon}
          fill="mediumEmphasis"
          size="14px"
        />
        <BodyText2 color="mediumEmphasis">
          {lullaby.looped
            ? t("loop")
            : time.duration(lullaby.duration).format("mm:ss")}
        </BodyText2>
      </Flex>
    </Flex>
  );
}

function LoadingContent({ t, audioController }) {
  return <AudioLoader onStop={() => audioController.pause()} />;
}

const contentByStatus = {
  [Status.PLAYING]: PlayingContent,
  [Status.RESTING]: RestingContent,
  [Status.LOADING]: LoadingContent
};

export default function LullabiesListItemContent({ audioController, lullaby }) {
  const { t } = useTranslation();
  const status = audioController.getStatusForIdentifier(lullaby.objectId);
  const Content = contentByStatus[status];

  return (
    <Flex ml="16px">
      <Content t={t} audioController={audioController} lullaby={lullaby} />
    </Flex>
  );
}
